import { NavItemSkeleton } from './NavItemSkeleton';

const NavigationLineSkeleton: React.FC<any> = ({ viewRef }) => {
  return (
    <div className="overflow-hidden overflow-x-auto my-10 mx-auto" ref={viewRef}>
      <div className="flex justify-between mb-2 pl-3" style={{ flexFlow: 'column nowrap' }}>
        <div className="bg-surface-200-bg inline-block w-36 h-6 leading-8 rounded-sm skeleton mb-2" />
      </div>
      <div className="max-w-full overflow-hidden flex">
        {new Array(6).fill(0).map((_item, index) => {
          return <NavItemSkeleton key={`navigation_line_item_${index}`} />;
        })}
      </div>
    </div>
  );
};

export default NavigationLineSkeleton;

const NavigationLineSkeletonV2: React.FC<any> = () => {
  return (
    <div className="max-w-full overflow-hidden flex gap-300 pl-300 mt-[15px] pb-2.5">
      {new Array(6).fill(0).map((_item, index) => {
        return (
          <div key={`navigation_line_item_${index}`}>
            <div className="bg-surface-200-bg inline-block w-[74px] h-[74px] rounded-full mb-300 skeleton" />
            <div className="bg-surface-200-bg w-full h-[15px] skeleton rounded-sm" />
          </div>
        );
      })}
    </div>
  );
};

export { NavigationLineSkeletonV2 };
